// extracted by mini-css-extract-plugin
module.exports = {"img":"style_img__v9efe"};